<template>
  <div class="o-forgot-password">
    <app-navigation :currentSpace="$t('web.forgot_password.nav_space')"></app-navigation>


    <main class="o-forgot-password__main">
      <section v-if="!email_sent" class="c-card">
        <form>
          <div class="c-card__header">
             <h2 class="c-card__title t-headline">{{ $t('web.forgot_password.card_header') }}</h2>
          </div>


          <div class="c-card__body">
            <fieldset class="o-fieldset">
              <label class="u-label">{{ $t('web.forgot_password.email_label') }}</label>
              <p class="c-card__p">{{ $t('web.forgot_password.email_hint') }}</p>
              <input
                v-model      = "request.primary_email"
                :class       = "{ 'is-not-valid': errors.primary_email }"
                type         = "email"
                :placeholder = "$t('web.forgot_password.email_placeholder')"
                required
              />
              <div
                v-if  = "errors.primary_email"
                class = "c-validation t-alert-danger"
                for   = "primary_email"
              >
                {{ errors.primary_email[0] }}
              </div>
            </fieldset>
          </div>


          <div class="c-card__footer">
            <router-link
              :to="{name: 'Login'}"
              class="c-card__footer__text-link u-tiny-note u-float-left t-link"
            >
              {{ $t('web.forgot_password.back_to_login') }}
            </router-link>
            <button
              @click = "submit($event)"
              class  = "c-button u-float-right t-button-primary"
            >
              {{ $t('web.forgot_password.send_button') }}
            </button>
          </div>
        </form>
      </section>


      <section class="c-card" v-if="email_sent">
        <div class="c-card__header">
          <h2 class="c-card__title t-headline">{{ $t('web.forgot_password.card_header') }}</h2>
        </div>

        <div class="c-card__body">
          <h2 class="u-h4">{{ $t('web.forgot_password.success_message') }}</h2>
          <p class="c-card__p">
            {{ $t('web.forgot_password.success_message_details') }}
          </p>
        </div>

        <div class="c-card__footer">
          <i18n path="web.forgot_password.success_goto_login" tag="p" class="u-tiny-note">
            <template v-slot:login_link>
              <router-link
                :to   = "{name: 'Login'}"
                class = "c-card__footer__text-link u-back-page t-link"
              >
                {{ $t('web.forgot_password.success_goto_login_link') }}
              </router-link>
            </template>
          </i18n>
        </div>
      </section>
    </main>


    <app-footer></app-footer>
  </div>
</template>




<script>
import $ from 'jquery'
import util from '@/functions'
import validate from 'validate.js'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'forgot-password',
  data () {
    return {
      request: {
        primary_email: null,
        platform_id: null,
        scope: ''
      },
      errors: {
        primary_email: null
      },
      email_sent: false,
      error_message: '',
      isLoggedIn: util.isLoggedIn()
    }
  },

  mounted () {
    if (this.isLoggedIn) {
      this.LOAD_PARTICIPANT(this.$router)
    }
    util.showPassword($('#password'))
    util.showPassword($('#password_confirmation'))
  },

  computed: {
    ...mapGetters({
      appName: 'appName',
      websiteConfig: 'websiteConfig'
    })
  },

  methods: {
    ...mapActions([
      'SEND_FORGOT_PASSWORD',
      'LOAD_PARTICIPANT'
    ]),

    submit (e) {
      e.preventDefault()
      this.error_message = ''
      this.errors = {primary_email: null}
      let errors = this.validate()
      if (errors) {
        this.errors = errors
        util.shake($('.c-card'))
        return
      }
      this.request.platform_id = this.websiteConfig.id
      this.SEND_FORGOT_PASSWORD(this.request)
        .then(resp => {
          switch (resp.data) {
            case 'passwords.sent':
              this.email_sent = true
              break
            case 'passwords.user':
              this.errors.primary_email = [this.$t('web.forgot_password.email_not_found')]
              util.highlight('email')
              break
          }
          return
        })
        .catch(() => {
          util.shake($('.c-card'))
          return
        })
    },

    validate () {
      const constraints = {
        primary_email: {
          email: {
            message: this.$t('utils.validation.email')
              .replace('{attribute}', validate.capitalize(validate.prettify('primary_email')))
          },
          presence: {message: this.$t('web.forgot_password.email_required')}
        }
      }
      return validate(this.request, constraints, {fullMessages: false})
    }

  }
}
</script>



// WEBPACK FOOTER //
// ForgotPassword.vue?605f7526